import { Tooltip } from "@mantine/core";
import { HiArrowRight } from "react-icons/hi2";
import CustomButton from "../../../ui/CustomButton/CustomButton";

export function NextReviewButton({ onNext, isLoading, canProceed, tooltipLabel }) {
  return (
    <Tooltip
      label={tooltipLabel ?? ""}
      withArrow
      position="top"
      disabled={canProceed || !tooltipLabel}
    >
      <span className="block">
        <CustomButton
          fullWidth
          color="primary"
          radius="md"
          rightSection={<HiArrowRight style={{ fontSize: 16 }} />}
          loading={isLoading}
          disabled={!canProceed || isLoading}
          onClick={onNext}
        >
          Next: Review Details
        </CustomButton>
      </span>
    </Tooltip>
  );
}
